import styled, { css } from "styled-components";
import { FlexColumn, FlexRowDiv, FlexRowSpaceBetween } from "../../common.styles";
import { HXAutocomplete } from "../../HXAutocomplete";
import { colors } from "healthex-common/colors";
import aiStarsIcon from "../../../Media/StarsBlack.svg";
import { HXIconButton } from "../../HXButton";
import React from "react";
import Download from "@mui/icons-material/Download";
import UploadFile from "@mui/icons-material/UploadFile";
import ErrorOutlineOutlined from "@mui/icons-material/ErrorOutlineOutlined";
import Close from "@mui/icons-material/Close";
import WarningAmberOutlined from "@mui/icons-material/WarningAmberOutlined";
export const InformedConsentTranslationContentContainer = styled(FlexColumn) `
    padding: 16px 0;
    gap: 32px;
`;
export const InformedConsentTranslationFilterRow = styled(FlexRowSpaceBetween) `
    align-items: center;
`;
export const InformedConsentTranslationFilterAutocomplete = styled(HXAutocomplete) `
    width: 250px;
`;
export const ManageTranslationsContainer = styled(FlexColumn) `
    gap: 32px;
    padding: 0px 24px 24px 24px;
    justify-content: space-between;
    flex: 1 0 0;
`;
export const ManageTranslationsContentContainer = styled(FlexColumn) `
    gap: 32px;
    flex: 1 0 0;
`;
export const ManageTranslationsRow = styled(FlexRowSpaceBetween) `
    padding: 8px 4px;
    align-items: center;
    border-radius: 4px;
    border: 1px solid ${colors.black_12};
`;
export const ManageTranslationsInnerRow = styled(FlexRowDiv) `
    align-items: center;
    justify-content: center;
`;
const BaseIcon = css `
    height: 24px;
    width: 24px;
    color: ${colors.navy_main};
`;
const AIIcon = styled.img.attrs({ src: aiStarsIcon }) `
    ${BaseIcon}
`;
const DownloadIcon = styled(Download) `
    ${BaseIcon}
`;
const UploadFileIcon = styled(UploadFile) `
    ${BaseIcon}
`;
const BannerCloseIcon = styled(Close) `
    ${BaseIcon}
    color: ${colors.black_lighter};
`;
export const ErrorOutlineOutlinedIcon = styled(ErrorOutlineOutlined) `
    ${BaseIcon}

    ${(props) => props.error &&
    css `
            color: ${colors.tulip_main};
        `}
`;
export const WarningAmberOutlinedIcon = styled(WarningAmberOutlined) `
    ${BaseIcon}

    ${(props) => props.error &&
    css `
            color: ${colors.sunset_main};
        `}
`;
export const ManageTranslationsAIButton = styled(HXIconButton).attrs({
    children: React.createElement(AIIcon),
}) ``;
export const ManageTranslationsDownloadButton = styled(HXIconButton).attrs({
    children: React.createElement(DownloadIcon),
}) ``;
export const ManageTranslationsUploadFileButton = styled(HXIconButton).attrs({
    children: React.createElement(UploadFileIcon),
}) ``;
export const TranslationsBannerCloseButton = styled(HXIconButton).attrs({
    children: React.createElement(BannerCloseIcon),
}) ``;
export const SegmentImage = styled.img `
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
`;
export const SegmentImageContainer = styled(FlexColumn) `
    min-height: 160px;
    border-radius: 4px;
    border: 2px solid ${colors.black_12};
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 16px;
    background: ${colors.white_background};

    &:hover:not([disabled]) {
        background: linear-gradient(0deg, #07142014 0%, #07142014 100%);
        transition: all 0.2s ease;
    }
`;
